import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {SettingsPage} from './settings';
import {ComponentsModule} from '../../../../shared/components/components.module';
import {SellionsTakePhoto} from "../../../../shared/components/sellions-take-photo/sellions-take-photo";
import {CameraService} from "../../services/camera-service/camera-service";

@NgModule({
  declarations: [
    SettingsPage
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(SettingsPage),
  ],
  providers: [CameraService],
  entryComponents: [SellionsTakePhoto]
})
export class SettingsPageModule {}



// WEBPACK FOOTER //
// ./src/modules/core/pages/settings/settings.module.ts